import type { MuscleWeek } from "../lib/api";
import { muscleLabel } from "../lib/format";

/** Шкала полосы: 25 подходов в неделю — край, дальше не бывает осмысленно. */
const SCALE = 25;
const LOW = 8;
const HIGH = 20;

const ZONE: Record<MuscleWeek["zone"], string> = {
  low: "мало",
  ok: "норма",
  high: "много",
};

/**
 * Подходы в неделю на группу с ориентирами (21-retention-plan.md §9).
 *
 * Многоугольник выше показывает доли — куда уходит работа. Эта карточка
 * отвечает на другой вопрос: «а этого хватает?». Полоса нормы подсвечена,
 * число — среднее за четыре недели, чтобы одна пропущенная тренировка не
 * объявляла группу заброшенной.
 */
export default function VolumeLandmarks({ rows }: { rows: MuscleWeek[] }) {
  if (rows.length === 0) return null;
  return (
    <div className="card vol">
      <p className="card__title">Подходы в неделю</p>
      <p className="vol__hint">
        Среднее за 4 недели. Ориентир для роста — {LOW}–{HIGH} рабочих подходов на группу.
      </p>
      {rows.map((row) => (
        <div className="vol__row" key={row.muscle}>
          <span className="vol__name">{muscleLabel(row.muscle)}</span>
          <span className="vol__track" aria-hidden="true">
            <span
              className="vol__band"
              style={{ left: `${(LOW / SCALE) * 100}%`, width: `${((HIGH - LOW) / SCALE) * 100}%` }}
            />
            <span
              className={`vol__fill vol__fill--${row.zone}`}
              style={{ width: `${Math.min(row.sets_per_week / SCALE, 1) * 100}%` }}
            />
          </span>
          <span className="vol__num">{row.sets_per_week.toLocaleString("ru-RU")}</span>
          <span className={`vol__zone vol__zone--${row.zone}`}>{ZONE[row.zone]}</span>
        </div>
      ))}
    </div>
  );
}
